import { Injectable, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { LoginValidationMessages } from '../models';
import { FormUtilsService } from '@app/@core';
import { NbToastrService } from '@nebular/theme';
import { AuthService } from '@app/@core-auth';
import { Router } from '@angular/router';
import { catchError, tap } from 'rxjs/operators';
import { forkJoin, BehaviorSubject, Observable, of } from 'rxjs';
import { untilComponentDestroyed, OnDestroyMixin } from '@w11k/ngx-componentdestroyed';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class LoginFormService extends OnDestroyMixin implements OnDestroy {
  private _loading$ = new BehaviorSubject<boolean>(false);
  readonly loading$: Observable<boolean>;
  readonly form: UntypedFormGroup;
  readonly validationMessages: LoginValidationMessages;

  constructor(
    private fb: UntypedFormBuilder,
    private formUtils: FormUtilsService,
    private router: Router,
    private auth: AuthService,
    private toastr: NbToastrService,
    private translate: TranslateService
  ) {
    super();

    this.form = this.fb.group({
      username: [null, Validators.required],
      password: [null, Validators.required]
    });
    this.validationMessages = {
      username: [{ type: 'required', message: ('err_field_required') }],
      password: [{ type: 'required', message: ('err_field_required') }]
    };
    this.loading$ = this._loading$.asObservable();
  }

  submit() {
    console.log('LoginFormService submit');
    if (this.form.valid) {
   
      this._loading$.next(true);
      this.auth
        .login(this.form.getRawValue())
        .pipe(
          tap(() => this._loading$.next(false)),
          catchError((err) =>
            forkJoin([this.translate.get(marker('login_failed_message')), this.translate.get(marker('login'))]).pipe(
              tap(([message, title]) => {
                this._loading$.next(false);
                //this.toastr.danger(message, title);
              })
            )
          ),
          untilComponentDestroyed(this)
        )
        .subscribe(() => {
          this.router.navigate(['']);
        });
    } else {
      this.formUtils.markAsDirty(this.form);
    }
  }

  ngOnDestroy() {super.ngOnDestroy();}
}
